import React, { useState } from 'react';
import MediaCard from '../media/media-card';
import ReelCard from '../media/reel-card';
import styles from './media.module.css';
import useMedia from '../../hooks/use-media';
import LoadingSpinner from '../common/loading-spinner';
import VideoModal from '../common/video-modal';
import SubscribeSection from '../sections/subscribe-section/subscribe-section';
import InstagramSection from '../sections/instagram-section/instagram-section';
import { MediaItem } from '../../types';

export default function Media() {
  const { items: mediaItems, loading } = useMedia();
  const [selectedMedia, setSelectedMedia] = useState<MediaItem | null>(null);

  const handlePlay = (item: MediaItem) => {
    setSelectedMedia(item);
  };

  return (
    <div id="media-page" className={styles.container}>
      <div className={styles.headerContent}>
        <h2 className={styles.title}>
          The New Rules of Women&rsquo;s Health in the Media
        </h2>
        <p className={styles.description}>
          Catch up on the latest interviews, podcasts, videos, and features.
        </p>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.grid}>
          {mediaItems.map((item) => (
            item.layout === 'reel' ? (
              <ReelCard key={item.id} item={item} onPlay={handlePlay} />
            ) : (
              <MediaCard key={item.id} item={item} onPlay={handlePlay} />
            )
          ))}
        </div>
      )}

      {selectedMedia && (
        <VideoModal
          item={selectedMedia}
          onClose={() => setSelectedMedia(null)}
        />
      )}

      <div className={styles.newsletterSection}>
        <p className={styles.softConfig}>
          Check back soon for more, or join the community to get updates on new resources, events, and media.
        </p>
        <div className={styles.newsletterWrapper}>
          <SubscribeSection />
          <InstagramSection />
        </div>
      </div>
    </div>
  )
}
